export default __webpack_public_path__ + "static/media/ic_default_profile_pic_square.a0d44923.svg";